import axios from "axios";
let apiData = {};
export function setAPIData(val) {
  apiData = val;
}
export function getAPIData() {
  return apiData;
}
function getDecryptedValue(str) {
  const formData = new FormData();
  formData.append("encryptedvalue", str);
  formData.append("userID", process.env.REACT_APP_ENC_USER_ID);
  formData.append("pwd", process.env.REACT_APP_ENC_USER_PWD);
  let promise = new Promise((res, rej) => {
    let flag = true;
    try {
      axios
        .post(`${getAPIData().url}/getDecrypted`, formData, {
          headers: {
            "Cache-Control": false,
            "eO2-Secret-Code": process.env.REACT_APP_EO2_SECRET_CODE,
            Accept: "application/json",
          },
        })
        .then((result) => {
          str = result?.data?.result?.decryptionValue;
          res(str);
          flag = false;
        })
        .catch((err) => {
          flag = false;
          return res(str);
        });
    } catch {
      flag = false;
      res(str);
    }
    setTimeout(() => {
      if (flag) {
        res(str);
      }
    }, 10000);
  });
  return promise;
}

// Nice
export function parseEncryptedData(data) {
  let promise;
  if (Array.isArray(data)) {
    promise = Promise.all(
      data.map((_) => {
        return parseEncryptedData(_);
      }),
    );
  } else if (typeof data === "object") {
    const arr = [];
    const parsedObj = {};

    for (let key in data) {
      const isEncryptedValue = key.indexOf("_DE") >= 0;
      const valuePromsified = isEncryptedValue
        ? getDecryptedValue(data[key])
        : parseEncryptedData(data[key]);
      if (isEncryptedValue) {
        key = key.substring(0, key.indexOf("_DE"));
      }
      arr.push(valuePromsified);
      (valuePromsified.then((val) => {
        parsedObj[key] = val;
      }),
        (val) => {
          return (parsedObj[key] = val);
        });
    }
    promise = Promise.all(arr)
      .then((_) => {
        return Promise.resolve(parsedObj);
      })
      .catch((_) => {
        return Promise.reject(parsedObj);
      });
  } else if (typeof data === "boolean" || typeof data === "number") {
    return Promise.resolve(data);
  } else if (typeof data === "string") {
    return Promise.resolve(data);
  }
  return promise;
}

export const apiConfig = {
  get: (path) => {
    return axios.get(`${getAPIData().url}${path}`).then((response) => {
      return parseEncryptedData(response.data);
    });
  },
  post: (path, form, header, localStorageMap, options) => {
    const formData = new FormData();
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    if (!options || !options.ignoreDefaults) {
      formData.append("userID", userData?.userID);
      formData.append("corporateID", userData?.corporateId);
      formData.append("tokenID", userData?.tokenID);
    }

    if (localStorageMap) {
      for (const key in localStorageMap) {
        formData.append(key, userData[localStorageMap[key]]);
      }
    }
    for (const key in form) {
      formData.append(key, form[key]);
    }

    return axios
      .post(`${getAPIData().url}${path}`, formData, {
        headers: {
          "Cache-Control": false,
          "eO2-Secret-Code": process.env.REACT_APP_EO2_SECRET_CODE,
          Accept: header ? header.Accept : "application/json",
        },
        ...(path.includes("export") ||
        path.includes("corporatdownloadeendorsementdeletionemplate") ||
        path.includes("corporatuploadandreadendorsmentaddition") ||
        path.includes("corporateemployeestatementperschemereport") ||
        path.includes("corporateemployeelistingreport") ||
        path.includes("corporateemployeelossratioperschemereport")
          ? { responseType: "blob" }
          : {}),
      })
      .then((response) => {
        if (
          response?.config?.url.includes("export") ||
          response?.config?.url?.includes(
            "corporatdownloadeendorsementdeletionemplate",
          ) ||
          response?.config?.url?.includes(
            "corporatuploadandreadendorsmentaddition",
          ) ||
          response?.config?.url?.includes(
            "corporateemployeestatementperschemereport",
          ) ||
          response?.config?.url?.includes("corporateemployeelistingreport") ||
          response?.config?.url?.includes(
            "corporateemployeelossratioperschemereport",
          )
        ) {
          return response;
        }

        if (options && options.returnFull) {
          return parseEncryptedData(response.data.result).then((result) => {
            return { ...response.data, result };
          });
        } else {
          if (response?.data?.totalPages) {
            return [
              parseEncryptedData(response.data.result),
              response?.data?.totalPages,
              response?.data?.totalRecords,
            ];
          } else {
            return parseEncryptedData(response.data.result);
          }
        }
      })
      .catch((_) => {
        return Promise.reject(_);
      });
  },
};
